
let gc = {
    hasInit: false,
    store: {
        _state: {

        }
    }
};
let util = new Map();
if(!my){
    var my = {};
}
let mpMapping = {
    wechat_mini:{
        getStorageSync:wx.getStorageSync,
        request:wx.request,
    },
    alipay_mini:{
        getStorageSync:my.getStorageSync,
        request:my.request,
    }
}
util.loadJS = function (url, callback) {
    var script = document.createElement('script'),
        fn = callback || function () { };
    script.type = 'text/javascript';
    script.onload = function () {
        fn();
    };
    script.onerror = function () {
        fn();
    };
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}

util.getUserInfo = function (channel) {
    let memberId = "";
    let userId = "";
    if (channel == "wechat") {
        let user = localStorage.user || "";
        let wxuser = localStorage.wxuser || localStorage.wxUser;
        if (user) {
            user = JSON.parse(user);
            if (user && user.memberId) {
                memberId = user.memberId;
            }
        }
        if (wxuser) {
            wxuser = JSON.parse(wxuser)
            if (wxuser && wxuser.openid) {
                userId = wxuser.openid;
            }
        }
    }
    if (channel !== "wechat") {
        function getStorage(key) {
            try {
                //var value = wx.getStorageSync(key);
                var value = mpMapping[channel].getStorageSync(key);
                if (value) {
                    return value;
                } else {
                    return ""
                }
            } catch (e) {
                return ""
            }
        }
        let user = getStorage("user") || getStorage("malluser");
        let wxuser = getStorage("wxuser") || getStorage("mallwxuser");
        if (user && user.memberId) {
            memberId = user.memberId
        }
        if (wxuser && wxuser.openid) {
            userId = wxuser.openid;
        }
    }
    return [memberId, userId];
}

util.send = function (sendObj, option) {

    try {
        var channel = option.channel || "wechat";
        var serverUrl = option.serverUrl || "https://api.wx.gcihotel.net/datacenterapi/behaviourDetails/saveBehaviourDetails";
        let timeout = 1000;
        if (channel == "wechat") {
            const controller = new AbortController();
            const { signal } = controller;
            new Promise(function(resolve, reject){
                let timeoutID = setTimeout(()=>{
                    controller.abort();
                    reject(console.error("fetch timeout"))
                }, timeout);
                fetch(serverUrl, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendObj),
                    signal
                }).then(function (response) {
                    clearTimeout(timeoutID)
                    resolve(response.json());
                }).catch(error => {
                    clearTimeout(timeoutID)
                    console.error('Error:', error)
                })
            })
           
        }
        if (channel !== "wechat") {
            var task = "";
            let request = mpMapping[channel].request;
            new Promise(function(resolve, reject){
                let timeoutID = setTimeout(()=>{
                    reject(console.error("request timeout"))
                    task.abort();
                }, timeout);
                task = request({
                    url: serverUrl,
                    data: sendObj,
					method:"POST",
                    header: {
                        'content-type': 'application/json'
                    },
                    success(res) {
                        clearTimeout(timeoutID)
                        resolve(res)
                        console.log(res);
                    },
                    fail(res){
                        clearTimeout(timeoutID)
                        reject(res)
                        console.log(res);
                    }
                })
            })

        }
    } catch (e) { }
}

util.request = function (obj) {
    return new Promise((resolve, reject) => {
        let channel = obj.channel||"wechat_mini";
        let request = mpMapping[channel].request;
        request({
            url: obj.url,
            data: obj.data,
            method: obj.method || "GET",
            header: {
                'content-type': 'application/json'
            },
            success(res) {
                resolve(res);
            },
            fail(err) {
                reject(err);
            }
        })
    })
}

util.urlEncode = function (param, key, encode) {
    if (param == null) return "";
    var paramStr = "";
    var t = typeof param;
    if (t == "string" || t == "number" || t == "boolean") {
        paramStr +=
            "&" +
            key +
            "=" +
            (encode == null || encode ? encodeURIComponent(param) : param);
    } else {
        for (var i in param) {
            var k =
                key == null
                    ? i
                    : key + (param instanceof Array ? "[" + i + "]" : "." + i);
            paramStr += util.urlEncode(param[i], k, encode);
        }
    }
    return paramStr;
}

util.getCurrentPath = function (channel) {
    var channel = channel || "wechat";
    let currentPath = "";
    if (channel == "wechat") {
        currentPath = window.location.href;
    }
    if (channel !== "wechat") {
        let pages = getCurrentPages();
        let currentPage = pages[pages.length - 1];
        let url = '/' + currentPage.route;
        let options = currentPage.options;
        currentPath = url + this.urlEncode(options).replace('&', '?');
    }
    return currentPath.length > 200 ? currentPath.substring(0, 200) : currentPath;
}

util.noop = function () {

}
util.isObject = function(obj){
    return typeof obj == "object"&&obj!=null;
}
gc.para = {
    appid: "",
    businessType: "shop",
    channel: "wechat",
    hotelGroupCode: "",
    serverUrl:"https://apidev.wx.gcihotel.net/datacenterapi/behaviourDetails/saveBehaviourDetails"
};

gc.initial = function () {
    this.store.init();
};

gc.setPara = function (para) {
    gc.para = Object.assign(gc.para, para);
};

gc.init = function (obj) {
    if (this.hasInit) {
        return false;
    }
    //正在初始化后才注入真正的埋点统计函数
    this.track = this[Symbol.track];
    //this.hasInit = true;
    this.setPara(obj);
	this.getSystemStoreInfo();
};

gc.getSystemStoreInfo = function () {

    let [memberId, userId] = util.getUserInfo(this.para.channel);
    this.setState("memberId", memberId);
    this.setState("userId", userId);
    this.getUserIp(this.para.channel);
}

gc.store.init = function () {
    gc.store._state = {
        behaviorType: 1,
        itemCategory: "",
        itemId: "",
        memberId: "",
        sourceIp: "",
        path: "",
        userId: ""
    }
}

gc.setState = function (key, value) {
    this.store._state[key] = value;
}

gc.getUserIp = function (channel) {
    var self = this;
    if(this.store._state.sourceIp||this.hasInit){
        return;
    }
    if (channel == "wechat") {
        util.loadJS('https://pv.sohu.com/cityjson?ie=utf-8', () => {
            try {
                if(returnCitySN["cip"]){
                    this.store._state.sourceIp = returnCitySN["cip"];
                }
            } catch (error) {
                
            }
           
            self.hasInit = true;
            self.nextSend();
        });
    }
    if (channel !== "wechat") {
        util.request({
            url: 'https://pv.sohu.com/cityjson?ie=utf-8',
            data: {

            },
            channel:channel
        }).then(res => {
            var m = JSON.parse(res.data.match(/.*(\{[^\}]+\}).*/)[1] || '{}');
            this.store._state.sourceIp = m.cip || "";
            self.hasInit = true;
            self.nextSend();
        })
    }
}

gc.track = function (obj) {
    this.getSystemStoreInfo();
    var trackObj = util.isObject(obj) ? obj : {};
    let sendObj = Object.assign({}, this.para, this.store._state, trackObj);
    sendObj.path = util.getCurrentPath(this.para.channel);

    this.send(sendObj);
}

gc.send = function (sendObj) {
    const {serverUrl,...needSend} = sendObj;
    let option = {
        channel:this.para.channel,
        serverUrl:serverUrl
    }
    this.sendQueue.push({
        needSend,
        option
    })
    this.nextSend();
    //util.send(needSend,option);
}

gc.sendQueue = [];

gc.nextSend = function(){
    if(!this.hasInit){
        return
    }
    this.sendQueue.forEach((n)=>{
        if(!n.needSend.sourceIp){
            n.needSend.sourceIp = this.store._state.sourceIp;
        }
    })
    while (this.sendQueue.length > 0) {
        let currentSend = this.sendQueue.shift();
        const {needSend,option} = currentSend;
        util.send(needSend,option);
    }
}
//当用户不调用init的函数的时候 track方法赋值空函数 兼容埋点关闭时候 无需各个埋点地方都做判断处理
gc[Symbol.track] = gc.track;

gc.track = util.noop;

gc.initial();

export default gc;



// WEBPACK FOOTER //
// ./src/utils/gc.js